module.exports = __webpack_public_path__ + "static/media/bingoactive.fb0e078b.png";